module.exports = __webpack_public_path__ + "img/iconfont.ee7fd3d9.svg";